import { useState } from 'react';

const REGION_COLORS = {
  'Fort Worth': '#3b82f6',
  'Dallas': '#8b5cf6',
  'Denton': '#06b6d4',
};

export default function RegionSection({ region, count, children }) {
  const [collapsed, setCollapsed] = useState(false);
  const color = REGION_COLORS[region] || '#6b7280';

  return (
    <div className={`region-section ${collapsed ? 'collapsed' : ''}`}>
      <div className="region-header" onClick={() => setCollapsed(!collapsed)}>
        <div className="region-title">
          <span className="region-dot" style={{ background: color }} />
          <h3>{region}</h3>
          <span className="region-count">{count}</span>
        </div>
        <span className={`collapse-icon ${collapsed ? 'rotated' : ''}`}>&#9660;</span>
      </div>
      {!collapsed && (
        <div className="region-body">
          {children}
        </div>
      )}
    </div>
  );
}
